import { Component, OnInit } from '@angular/core';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { cancelleriaTelematicaConfig } from './config';
import { pdaConfiguration } from '../../utils/pda-configuration';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { PdaAccessToken, PdaAuthService } from '../../utils/Service/pda-auth.service';
import { Router } from '@angular/router';
import { SectionsServiceTsService } from '../../utils/Service/sections.service.ts.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { AggiornamentoMassivoDisclaimerComponent } from './components/aggiornamento-massivo-disclaimer/aggiornamento-massivo-disclaimer.component';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';

@Component({
  selector: 'main [cancelleria-telematica]',
  templateUrl: './cancelleria-telematica.component.html',
  styleUrls: ['./cancelleria-telematica.component.css'],
  host: {'[attr.id]': '\'content\'' },
})

export class CancelleriaTelematicaComponent implements OnInit {
  config: Array<{label: string, url: string, class: string}>  = cancelleriaTelematicaConfig;
  enableConfig = false;
  constructor(private viewManager: ViewManagerService,
    private auth: PdaAuthService,
    private router: Router,
    private sectionService: SectionsServiceTsService,
    private modalNotifyService: ModalNotifyService,
    private dialog: DialogService) {

    }

  ngOnInit(): void {
    this.viewManager.svuotaMenu();
    this.auth.isLogged.subscribe(
      // x => this.enableConfig = x
      x => {
        this.enableConfig = x;
        if(!x) this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
      }
    )
  }

  onAction(element: {label: string, url: string, class: string}){
    if(element.class != "aggiornamento_massivo"){
      this.router.navigate([element.url]);
    }
    else{
      const ref = this.dialog.open(AggiornamentoMassivoDisclaimerComponent, {
        data: {
          style: {
            width: '30%',
          },
          title: 'Aggiornamento Massivo',
        }
      });
      ref.afterClosed.subscribe(async (event) => {
        if(!event || event.closeEvent) return;
        if(event.modalEvent === true) {
          let token: PdaAccessToken = await this.auth.getPdaToken();
          this.sectionService.consultazioneMassiva(token).subscribe(
            (res) => {
              let numFascicoliConsultati = (!!res && res.numFascicoliConsultati != null) ? res.numFascicoliConsultati : 0;
              this.modalNotifyService.customMessage(
                "Aggiornamento massivo dei fascicoli avvenuto con successo: consultati " +
                numFascicoliConsultati +
                " fascicoli");
            }
          );
        }
      });
    }
  }

}
